import axios from 'axios';

export const getUserPage = (filter) => {
  const queryString = Object.keys(filter).map((key) => `${key}=${filter[key]}`).join('&');
  return axios.get(`/usuario/get?${queryString}`);
};

export const getPaginaDeRegistros = (pagina, filter, perfil) => {
  const queryString = Object.keys(filter).map((key) => `${key}=${filter[key]}`).join('&');
  return axios.get(`/usuario/perfil/${perfil}/grid?page=${pagina}&sort=usuario.nome&${queryString}`);
};

export const verificarUsuarioJaCadastrado = (sub) => (axios.get(`/usuario/${sub}/cadastrado`))
export const getById = (id) => axios.get(`/usuario/${id}`);
export const getBySub = (sub) => axios.get(`/usuario/sub/${sub}`);
export const countNaoAprovados = () => axios.get('/usuario/quantidade-nao-aprovados')
export const getRoles = (sub) => axios.get(`/usuario/sub/${sub}/roles`);
export const recuperarAtuacoes = () => (axios.get('/atuacao'));
export const cadastrarUsuario = (data) => (axios.post('/usuario', data));
export const alteraUsuario = (id, data) => (axios.put(`/usuario/${id}`, data));
export const getSelectedRole = (sub) => axios.get(`/usuario/sub/${sub}/role`);
export const atualizaUserRole = (sub, data) => axios.put(`/usuario/sub/${sub}/role`, data);
export const aceitar = (idUsuario, idUsuarioPerfil) => axios.put(`/usuario/${idUsuario}/perfil/${idUsuarioPerfil}/aceitar`);
export const recusar = (idUsuario, idUsuarioPerfil) => axios.put(`/usuario/${idUsuario}/perfil/${idUsuarioPerfil}/recusar`);
export const ativar = (idUsuario, idUsuarioPerfil) => axios.put(`/usuario/${idUsuario}/perfil/${idUsuarioPerfil}/ativar`);
export const desativar = (idUsuario, idUsuarioPerfil) => axios.put(`/usuario/${idUsuario}/perfil/${idUsuarioPerfil}/desativar`);
export const compartilharCard = (idUsuarioPerfil, email) => axios.get(`/usuario/perfil/${idUsuarioPerfil}/compartilhar-card-por-email?email=${email}`);
export const getNaoAprovados = (perfil) => axios.get(`/usuario/perfil/${perfil}/nao-aprovados`);
export const getByTitularidade = (idTitularidade, idAtuacao) => axios.get(`/usuario/titularidade/${idTitularidade}/atuacao/${idAtuacao}`);
export const compartilharDetalhamento = (id, email) => axios.get(`/usuario/${id}/compartilhar-detalhamento-por-email?email=${email}`);
